/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LiveBellIconLocal = {
    readonly notificationCount: number | null;
    readonly " $refType": "LiveBellIconLocal";
};
export type LiveBellIconLocal$data = LiveBellIconLocal;
export type LiveBellIconLocal$key = {
    readonly " $data"?: LiveBellIconLocal$data;
    readonly " $fragmentRefs": FragmentRefs<"LiveBellIconLocal">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LiveBellIconLocal",
    "selections": [
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "notificationCount",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Local",
    "abstractKey": null
} as any);
(node as any).hash = 'b13a3927ed68ff105901b7fcea04e701';
export default node;
